export default __webpack_public_path__ + "static/media/nft5.f2593afa.png";